module.exports = __webpack_public_path__ + "img/sb.79392615.svg";